import {Component} from '@angular/core';
import {TranslationService} from '@spartacus/core';
import {
  Configurator,
  ConfiguratorAttributeCompositionContext,
  ConfiguratorAttributeReadOnlyComponent,
} from '@spartacus/product-configurator/rulebased';
import moment from 'moment';
import {DcpUiType} from '../../models';
import CustomUiTypeIndicator = Configurator.CustomUiTypeIndicator;

@Component({
  selector: 'dcp-configurator-attribute-read-only',
  templateUrl: './dcp-configurator-attribute-read-only.component.html',
  styleUrls: ['./dcp-configurator-attribute-read-only.component.scss'],
  standalone: false,
})
export class DcpConfiguratorAttributeReadOnlyComponent extends ConfiguratorAttributeReadOnlyComponent {
  moment = moment;
  uiType = DcpUiType;
  isDate = (value: any) =>
    this.attribute.uiTypeVariation?.endsWith(CustomUiTypeIndicator + this.uiType.DATE) &&
    moment(value.valueDisplay).isValid();

  constructor(
    translationService: TranslationService,
    attributeComponentContext: ConfiguratorAttributeCompositionContext,
  ) {
    super(translationService, attributeComponentContext);
  }
}
